import { render } from "./LoginFormNotify.vue?vue&type=template&id=545aa778&scoped=true"
import script from "./LoginFormNotify.vue?vue&type=script&lang=js"
export * from "./LoginFormNotify.vue?vue&type=script&lang=js"

import "./LoginFormNotify.vue?vue&type=style&index=0&id=545aa778&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545aa778"]])

export default __exports__